export const KeyOrgID = 'org_id';
export const KeyIsValid = 'is_valid';
export const KeyType = 'type';
export const KeyRuleId = 'rule_id';
export const KeyRuleIdSub = 'rule_id_sub';
export const KeyRuleName = 'rule_name';
export const KeyRuleCondition = 'rule_condition';
export const KeySceneName = 'scene_name';
export const KeyAreaName = 'area_name';
export const KeyLabel = 'label';
export const KeyMaterialName = 'material_name';
export const KeyMaterialId = 'material_id';
export const KeyOptions = 'options';
export const KeySummaryItems = 'summaryItems';
export const KeySummaryItem = 'summary_item';
export const KeyOptionsNumber = 'options_number';
export const KeyStartDatetimeUtc = 'start_datetime_utc';
export const KeyEndDatetimeUtc = 'end_datetime_utc';
export const KeyTmStartTimeUtcFrom = 'tm_start_time_utc_from';
export const KeyTmStartTimeUtcTo = 'tm_start_time_utc_to';
export const KeyEndType = 'end_type';
export const KeyEndTypeNormal = '1';
export const KeyResult = 'result';
export const KeyAverageAnswerTimeOK = 'average_answer_time_ok';
export const KeyAverageAnswerTimeNG = 'average_answer_time_ng';
export const KeyResultOK = 'OK';
export const KeyResultNG = 'NG';
export const KeyIsUpdate = 'isUpdate';
export const KeyMaterialCount = 'material_count';
export const KeyUserName = 'user_name';
export const KeyExperiencerName = 'experiencer_name';
export const KeyDeviceId = 'device_id';
export const KeySummaryFilterCondition = 'summary_filter_condition';
export const KeyIsDashboardEnabled = 1;
export const KeySessionBaseData = 'session_base_data';
export const KeyInvalidOrgId = '9999999999XXXXXXXXXX';
export const KeyDownloadType = 'download_type';

export const LabelMaterialName = '教材';
export const LabelSceneName = 'シーン';
export const LabelQuestionName = '設問';
export const LabelDropdownMessage = 'を選択してください';
export const LabelStartDatetimeUtc = 'FROM：';
export const LabelToDatetimeUtc = 'TO：';
export const LabelEndType = '表示対象';
export const LabelSummaryRule = '集計ルール';
export const LabelSummaryTarget = '集計対象';
export const LabelSummaryTargetFilter = '集計対象絞込';
export const LabelSummaryRuleName = '集計ルール名';
export const LabelSummaryLabelName = 'ラベル名';
export const LabelSummaryRuleRowAdd = '行追加';
export const LabelSummaryRuleRowDelete = '行削除';
export const LabelSummaryRuleSave = '保存';
export const LabelSummaryRuleDelete = '削除';
export const LabelSummaryItemDatetime = '日時';
export const LabelListMaterialName = '教材名';
export const LabelListSceneName = 'シーン名';
export const LabelListStartDatetimeUtc = 'シーン開始日時';
export const LabelListEndDatetimeUtc = 'シーン終了日時';
export const LabelListUserName = 'ユーザー名';
export const LabelListExperiencerName = '体験者名';
export const LabelListDeviceId = 'デバイスID';
export const LabelSelfStudyDetailSummaryDetailTableTitle = 'シーンの一覧と再生回数';
export const LabelSidebarTrainingTitle = '研修型';
export const LabelSidebarSelfStudyTitle = '自由受講型';
export const LabelCsvExportLink = 'CSVエクスポート';
export const LabelCsvDownloadLink = 'CSVダウンロード';
export const LabelCsvDownload = 'ダウンロード';

// export const GraphBaseColor = "#00b0b9";
export const GraphBaseColor = '#1565C0';
export const GraphSubColor = '#c95179';
export const SearchItemColor = '#f9f9f9';
// export const SearchItemColor = '#efefef';
export const SearchItemBorderColor = '#b0b0b0';
export const BackGroundMainColor = '#ffffff';
export const RankingRowBaseColor = '#ffffff';
export const RankingRowSubColor = '#f1f1f1';
export const RefreshDispalyMSTime = 5000;
export const SummaryRuleNameMaxLength = 255;
export const SummarySettingsSwitchButtonColor = '#1976d2';

export const ErrorMessageSignIn =
  'ユーザー名またはパスワードが違います。\n' + 'Incorrect username or password.';
export const ErrorMessageResetPassword = 'ユーザー名が違います。\n' + 'Incorrect username.';
export const ErrorMessageInvalidVerifyCode =
  '無効な確認コードが入力されました。\nもう一度お試しください。\n' +
  'Invalid verification code provided,\nplease try again.';
export const ErrorMessageRequiredInput =
  'このフィールドを入力してください。\n' + 'Please fill out this field.';
export const ErrorMessagePasswordRequirements =
  'パスワードは以下の条件を全て満たしてください。\n' +
  ' - 8文字以上\n' +
  ' - アルファベット大文字を1文字以上\n' +
  ' - アルファベット小文字を1文字以上\n' +
  ' - 数字を1を1文字以上\n' +
  ' - 先頭と末尾に半角スペースを設定しない\n' +
  '\n' +
  'The password must meet all of the following conditions:\n' +
  ' - At least 8 characters\n' +
  ' - At least one uppercase letter\n' +
  ' - At least one lowercase letter\n' +
  ' - At least one number\n' +
  ' - Do not use spaces at the beginning or end';
export const ErrorMessageLimitExceeded =
  '試行回数が上限に達しました｡\nしばらくしてからもう一度お試しください｡ \n' +
  'Attempt limit exceeded.\n please try after some time.';
export const ErrorMessageExceptionJapanese = '予期せぬエラーが発生しました。\n';
export const ErrorMessageSummaryRuleNameMaxLength =
  '最大' + SummaryRuleNameMaxLength + '文字までです';
export const ErrorMessageCSVDownloadTarget = 'ダウンロード対象を選択してください。';
export const ErrorMessageCSVDownloadDateRange = 'FROM日付はTO日付より前の日付を指定してください。';

export const EndTypes = [
  { id: 1, name: '正常終了' },
  { id: 2, name: 'ポーズ' },
  { id: 4, name: 'シーン中断' },
  { id: 5, name: 'シーン移動' },
  { id: 6, name: 'シーンクリック移動' },
  { id: 9, name: '強制終了' },
];

export const AwsErrorMessages = [
  { orgMsg: 'Incorrect username or password.', msg: ErrorMessageSignIn },
  { orgMsg: 'Username/client id combination not found.', msg: ErrorMessageResetPassword },
  {
    orgMsg:
      "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[S]+.*[S]+$",
    msg: ErrorMessagePasswordRequirements,
  },
  {
    orgMsg: 'Invalid verification code provided, please try again.',
    msg: ErrorMessageInvalidVerifyCode,
  },
  {
    orgMsg: 'Attempt limit exceeded, please try after some time.',
    msg: ErrorMessageLimitExceeded,
  },
];

export const SummaryRuleOption = [
  { key: '1', value: '教材名' },
  { key: '2', value: 'シーン名' },
  { key: '3', value: 'デバイス名' },
  { key: '4', value: 'ユーザー名' },
  { key: '5', value: '体験者名' },
  //  { key: "5", value: '日時' },
];

export const DownloadCSVTypes = [
  { key: 1, value: 'material' },
  { key: 2, value: 'scene' },
  { key: 3, value: 'area' },
  { key: 4, value: 'areaInOut' },
];
